import stylesheet0 from "@oneappexchange/appx-font-utilities";
import stylesheet1 from "@oneappexchange/appx-grid";

function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return "a:hover" + shadowSelector + " {text-decoration: none;}.summary-reviews" + shadowSelector + " {display: flex;align-items: center;}.rating-stars" + shadowSelector + " {min-width: 124px;display: flex;align-items: center;}.label" + shadowSelector + " {display: inline-flex;font-weight: bold;color: var(--sds-g-color-palette-neutral-20);}@media (max-width: 767px) {.rating-stars" + shadowSelector + " {align-items: flex-start;}}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet0, stylesheet1, stylesheet];